var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddFolder = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48036414,0 L10.789,2.858 L13.5,2.858 L13.5,5.858 L9.35480069,5.85714286 L7.047,3 L3,3 L3,13.572 L17.143,13.572 L17.142,9.5 L20.142,9.5 L20.1428571,16.5714286 L0,16.5714286 L0,0 L8.48036414,0 Z M19.5022321,1.5 L19.5022321,3.55915179 L21.3549107,3.55915179 L21.3549107,5.34486607 L19.5022321,5.34486607 L19.5022321,7.41517857 L17.6495536,7.41517857 L17.6495536,5.34486607 L15.7857143,5.34486607 L15.7857143,3.55915179 L17.6495536,3.55915179 L17.6495536,1.5 L19.5022321,1.5 Z",
    id: "Combined-Shape",
    fill: "#9CA4B5",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-folder.8b2bfc9d.svg";
export { ForwardRef as ReactComponent };